module.exports = __webpack_public_path__ + "media/mom.db2f0dc3.mp3";